module.exports = __webpack_public_path__ + "static/media/ftu-mhr.a6e213e0.svg";